/* loaded by smart-asset */
export default require("./assets/attention.ogg")